<template>
  <!-- ljuska bloka na pocetnoj i u bocnim kolonama: naslov (link), gore desno padajuca lista ili "Pogledaj sve", telo u slotu
       (koriste je AdsBlock i EventsBlock; redovi imaju stilove u assets/scss/adRow.scss) -->
  <div class="card w-100" :class="{ 'block-news-height': height === 'news' }">
    <div
      class="card-body pb-card-display p-element-page"
      :class="{ 'block-event-height-index': height === 'event', 'block-items-height-index': height === 'items' }"
    >
      <div v-if="dropdownItems.length" class="float-end">
        <BDropdown lazy variant="white" toggle-class="p-0 mb-3">
          <template #button-content>
            <span class="font-size-13 text-uppercase">
              {{ dropdownLabel }}
              <!-- <i class="esei icon-chevron-down ml-1"></i> -->
            </span>
          </template>

          <NuxtLink
            v-for="entry in dropdownItems"
            :key="entry.key"
            class="dropdown-item"
            :to="entry.to"
          >
            {{ entry.label }}
          </NuxtLink>
        </BDropdown>
      </div>

      <NuxtLink v-else-if="moreTo" :to="moreTo" class="float-end font-size-13 text-uppercase" :class="moreClass">
        {{ moreLabel }}
      </NuxtLink>

      <NuxtLink :to="titleTo">
        <component :is="titleTag" class="card-title bc-title mb-4 font-size-13 text-uppercase">{{ title }}</component>
      </NuxtLink>

      <div class="adr-list">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { BDropdown } from 'bootstrap-vue-next'

defineProps({
  title: { type: String, default: '' },
  // oznaka naslova bloka: "div" (obican tekst, bocni blokovi) ili "h2"/"h3" kad je blok glavni sadrzaj
  titleTag: { type: String, default: 'div' },
  titleTo: { type: [String, Object], required: true },
  // padajuca lista: [{ key, label, to }]; ako je prazna, prikazuje se link "Pogledaj sve" (kad je zadat moreTo)
  dropdownItems: { type: Array, default: () => [] },
  dropdownLabel: { type: String, default: 'Kategorije' },
  moreTo: { type: [String, Object], default: null },
  moreLabel: { type: String, default: 'Pogledaj sve' },
  moreClass: { type: String, default: 'text-muted' },
  // visina kartice: 'items' (oglasi), 'event' (dogadjaji) ili 'news' (kao Vesti na pocetnoj: Recepti, Kako pomaze)
  height: { type: String, default: 'items' },
})
</script>
